// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `MenuDivider` component.
 */
const MenuDivider = ({ baseClassName, className, ...props }) => (
    <li className={classNames(baseClassName, className)} {...props} />
);

MenuDivider.propTypes = {
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

MenuDivider.defaultProps = {
    className: null,
    baseClassName: `${CLS_PREFIX}menu__divider`,
};

export default MenuDivider;



// WEBPACK FOOTER //
// ./components/Menu/MenuDivider.js